import { render, staticRenderFns } from "./PostsPreviewDialog.vue?vue&type=template&id=6f50e29d&scoped=true&"
import script from "./PostsPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./PostsPreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./PostsPreviewDialog.vue?vue&type=style&index=0&id=6f50e29d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f50e29d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VImg})
